const WaveEffect = ({ mainContainerClassName = "", textClassName = "", text = "" }) => {
  
  return (
    <div className={`wave-text ${mainContainerClassName}`}>
      {text.split("").map((char, index) => (
        <span
          className={textClassName}
          key={index}
          style={{
            animationDelay: `${index * 0.030}s`, whiteSpace: char === " " ? "pre" : "normal"
          }}
        >
          {char}
        </span>
      ))}
    </div>
    )
}


export default WaveEffect;
